<template>
    <div class="relative flex items-center">
        <select :value="selected"
                :aria-label="label"
                class="w-full cursor-pointer appearance-none truncate rounded-full border border-brand-blue-gray bg-white py-2.5 pl-3.5 pr-9 text-[13px]/5 text-brand-teal focus:border-brand-lime focus:outline-none focus:ring-1 focus:ring-brand-lime sm:w-[190px] sm:pl-4 sm:text-sm"
                @change="$emit('select', $event.target.value)">
            <option value="">{{ placeholder }}</option>
            <option v-for="option in options" :key="option" :value="option">{{ option }}</option>
        </select>

        <span class="pointer-events-none absolute right-4 flex text-brand-teal" aria-hidden="true">
            <svg class="h-3 w-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"></path></svg>
        </span>
    </div>
</template>

<script setup>
defineProps({
    selected: {
        type: String,
        default: '',
    },
    label: {
        type: String,
        required: true,
    },
    placeholder: {
        type: String,
        required: true,
    },
    options: {
        type: Array,
        default: () => [],
    },
});

defineEmits(['select']);
</script>
